import axios from "axios";
import { BASE_URL_STRING } from "./axios";

export const BASE_URL = BASE_URL_STRING;
export const EndPoints = {
  generateCodes: "/generate-codes",
  
};

export const createCodesAPIEndpoint = (endpoint) => {
  let url = BASE_URL + "v1/codes" + endpoint + "/";
  const token = sessionStorage.getItem("token");
  return {
    fetch: (options) =>
      axios.get(url, {
        ...options,
        headers: { Authorization: `Bearer ${token}` },
      }),

    post: (newRecord) => axios.post(url, newRecord),
    postWithToken: (newRecord) =>
      axios.post(url, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    postById: (id, data, config = {}) =>
      axios.post(url + id, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        ...config,
      }),
    putWithToken: (id, updatedRecord) =>
      axios.put(url + id, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    delete: (id) =>
      axios.delete(url + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
};
